import ProfileEdit from './ProfileEdit';

export default {
  edit: ProfileEdit
};
